import React from "react";

import { PopoverContext } from "./popoverContext";

import { usePopover } from "@components/organisms/popover/usePopover";
import type { IPopoverOptions } from "@components/organisms/popover/types";

export function Popover({
  children,
  modal = false,
  ...restOptions
}: {
  children: React.ReactNode;
} & IPopoverOptions) {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const popover = usePopover({ modal, ...restOptions });

  return (
    <PopoverContext.Provider value={popover}>
      {children}
    </PopoverContext.Provider>
  );
}
